import { Check } from "lucide-react";
import { cn } from "@/lib/cn";
import { IconeColorido } from "./IconeColorido";
import { iconeDaCategoria } from "./icones-da-selecao";

/**
 * Cartão grande de categoria (ou especialidade): ícone, nome e, à direita, quantos estão marcados
 * em destaque ("4/9"). Fica verde quando tem algo marcado — pedido do Jun.
 */
export function CartaoDeCategoria({
  titulo,
  detalhe,
  marcados,
  total,
  aberto,
  compacto,
  onClick,
}: {
  titulo: string;
  /** Linha pequena embaixo do nome ("9 serviços"). */
  detalhe: string;
  marcados: number;
  total: number;
  /** Quando o cartão abre uma lista embaixo (em vez de só marcar). */
  aberto?: boolean;
  /** Menor, pra dentro de um diálogo (famílias de material). */
  compacto?: boolean;
  onClick: () => void;
}) {
  const destacado = marcados > 0;
  const completo = total > 0 && marcados === total;
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={aberto === undefined ? completo : undefined}
      aria-expanded={aberto}
      className={cn(
        compacto
          ? "relative flex h-full min-h-[60px] w-full items-center gap-2.5 rounded-lg border px-3 py-2.5 text-left transition-colors"
          : "relative flex h-full min-h-[84px] w-full items-center gap-3 rounded-xl border p-3.5 text-left transition-colors",
        destacado
          ? "border-emerald-500 bg-emerald-50 dark:border-emerald-500/70 dark:bg-emerald-500/10"
          : "border-zinc-200 bg-white hover:border-brand-300 hover:bg-zinc-50 dark:border-border dark:bg-card dark:hover:bg-muted/40",
        aberto && "ring-2 ring-brand-600/30",
      )}
    >
      <IconeColorido {...iconeDaCategoria(titulo)} tamanho={compacto ? "md" : "xl"} />
      <span className="min-w-0 flex-1">
        <span className={cn("block text-sm font-semibold leading-snug", destacado ? "text-emerald-900 dark:text-emerald-300" : "text-zinc-900 dark:text-foreground")}>
          {titulo}
        </span>
        <span className="mt-0.5 block text-xs tabular-nums text-zinc-500 dark:text-muted-foreground">{detalhe}</span>
      </span>
      <span className={cn("flex shrink-0 items-baseline gap-0.5 tabular-nums", destacado ? "text-emerald-700 dark:text-emerald-300" : "text-zinc-300 dark:text-muted-foreground/50")}>
        {completo && <Check className="mr-0.5 h-4 w-4 self-center" strokeWidth={3} />}
        <span className={cn("font-bold leading-none", compacto ? "text-lg" : "text-2xl")}>{marcados}</span>
        <span className="text-xs font-medium">/{total}</span>
      </span>
    </button>
  );
}
